import { EMAIL_REGEXP, nameRegex } from '@moda/portal-stanchions';
import { RestAddressAttributes } from '../../../hooks/useAddress';

export const getValidations = (address: RestAddressAttributes) => ({
  firstName: {
    required: {
      message: 'Please enter first name',
      value: true
    },
    pattern: {
      message: 'Please enter a valid name',
      value: nameRegex
    }
  },
  lastName: {
    required: {
      message: 'Please enter last name',
      value: true
    },
    pattern: {
      message: 'Please enter a valid name',
      value: nameRegex
    }
  },
  addressLine1: {
    required: {
      message: 'Please enter an address',
      value: true
    },
    pattern: {
      message: "Address shouldn't contain an email address",
      value: new RegExp(`^(?!.*${EMAIL_REGEXP.source}).*$`)
    }
  },
  addressLine2: {
    differentFrom: {
      message: 'Address and Address Line 2 should be different',
      value: address.addressLine1
    },
    pattern: {
      message: "Address Line 2 shouldn't contain an email address",
      value: new RegExp(`^(?!.*${EMAIL_REGEXP.source}).*$`)
    }
  },
  city: {
    required: {
      message: 'Please enter a city',
      value: true
    },
    pattern: {
      message: 'Please enter a valid name',
      value: nameRegex
    }
  },
  state: {
    required: {
      message: 'Please select or enter a state/region',
      value: address.countryCode === 'US'
    },
    pattern: {
      message: 'Please enter a valid name',
      value: nameRegex
    }
  },
  postalCode: {
    required: {
      message: 'Please enter a zip/postal code',
      value: address.countryCode === 'US'
    }
  },
  phone: {
    required: {
      message: 'Phone must be at least 7 digits',
      value: address.countryCode !== 'US'
    },
    phoneNumber: {
      message: 'Invalid phone number.',
      value: true
    }
  }
});
